function Qaab(){
    return(
        <div className="qayb_ Qaabka">
        <h2><i className="fa-solid fa-sack-dollar"></i> Qaabka Xisaabinta</h2>
        <div className="Dooro t1aad">
            <h1>Dooro Nooca Sakada</h1>
            <div className="Noocyo">
                <ul>
                    <li>
                        lacag
                    </li>
                    <li>
                        geel
                    </li>
                    <li>
                        Lo,a
                    </li>
                    <li>
                        Adhi
                    </li>
                    <li>
                       Dahab
                    </li>
                </ul>
            </div>
        </div>
        <div className="Dooro t2aad">
            <h1>Qor Xadiga</h1>
            <div className="Noocyo">
                <ul>
                    <li>
                        8,000 $
                    </li>
                    <li>
                        60 Neef
                    </li>
                    <li>
                        105 Giraam
                    </li>
                </ul>
            </div>
        </div>
        <div className="Dooro t3aad">
            <h1>Waxaad Heli Jawaab sax</h1>
            <div className="Noocyo Jawaab">
                <ul>
                    <li>
                        <i className="fa-solid fa-clock"></i>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    )
}

export default Qaab